itsoftApp.createModule("clipboard", function () {
    itsoftApp.loadScript("/assets/scripts/clipboard.min.js", function () {
        let newClipboard = new ClipboardJS('.js-copy-button');
        const tooltipMini = document.querySelector('.js-copy-tooltip');

        if (tooltipMini) {
            newClipboard.on('success', function(e) {
                e.clearSelection();

                if (!tooltipMini.classList.contains('_show')) {
                    tooltipMini.classList.add('_show');
                    setTimeout(() => {
                        tooltipMini.classList.remove('_show');
                    }, 2000);
                }
            });
        }
    });
});
